<template>
	<div class="align-middle flex-container number-input">
		<button
			:class="['square-button', {disabled : disableDecrement || disabled}]"
			:disabled="disableDecrement || disabled"
			@click.prevent="$emit('change', {value: value - 1})"
			dusk="quantity-decrement-button"
		>
			<i class="icon" v-html="Icon.MINUS"></i>
		</button>
		<p class="text-center value color-alt-gray medium">{{ value + suffix }}</p>
		<button
			:class="['square-button', {disabled : disabled || disableIncrement}]"
			:disabled="disabled || disableIncrement"
			@click.prevent="$emit('change', {value: value + 1})"
			dusk="quantity-increment-button"
		>
			<i class="icon" v-html="Icon.PLUS"></i>
		</button>
	</div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Icon } from '@/front/icons';

@Component
export default class NumberInput extends Vue
{
	@Prop({type: Number, default: 0})  		readonly value!: number;
	@Prop(Boolean) 					   		readonly allowNegative!: boolean;
	@Prop({type: Boolean, default: true})	readonly allowPositive!: boolean;
	@Prop(Boolean) 					   		readonly disabled!: boolean;
	@Prop(Number)  					   		readonly minimumAmount!: number;
	@Prop({type: String, default: ''}) 		readonly suffix!: string;

	get disableDecrement() {
		return ((!this.allowNegative && this.value <= 0) || (this.value <= this.minimumAmount));
	}

	get disableIncrement() {
		return !this.allowPositive && this.value >= 0;
	}

	get Icon() {
		return Icon;
	}
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.value {
	min-width: 20px;
    margin: 0 10px;
}

.number-input {
	button {
		&.square-button {
			width: 30px;
			height: 30px;
			border-radius: var(--global-radius);
			opacity: .64;
			transition: opacity .3s;
		}

		&.disabled {
			opacity: .32;
			cursor: default;

			&:hover {
				opacity: .32;
			}
		}

		&:active, &:hover {
			opacity: 1;
		}

		&:focus {
			outline: none;
		}

		.icon {
			width: 30px;

			path {
				fill: var(--dark-gray);
			}
		}
	}
}

</style>